export const SET_ALERTAS = 'SET_ALERTAS';
export const VEICULO = {
    BY_PK: 'BY_PK_VEICULO',
    SET_ONE: 'SET_ONE_VEICULO'
};

export const POSITIONS = {
    BY_PK: 'BY_PK_POSITIONS',
    SET_ONE: 'SET_ONE_POSITIONS'
};
